<template>
  <p v-if="hint" class="ai-quota-hint" :class="{ empty: remaining === 0 }">
    {{ hint }}
    <span v-if="units > 1"> Cada gravação usa {{ units }}.</span>
    <button v-if="canManageBilling" type="button" @click="openUpgrade">
      Assinar: 50 por dia
    </button>
  </p>
</template>

<script>
import { aiQuota, aiQuotaHint } from "@/utils/aiQuota";
import { track } from "@/utils/analytics";

// Remaining AI actions next to the AI buttons, shown only when the allowance is low (Grátis/trial).
export default {
  name: "ComponentAiQuotaHint",
  props: {
    units: { type: Number, default: 1 },
    where: { type: String, default: "" },
  },
  computed: {
    company() {
      return this.$store.state.Companies.company || {};
    },
    hint() {
      return aiQuotaHint(this.company);
    },
    remaining() {
      return aiQuota(this.company).remaining;
    },
    canManageBilling() {
      const user = this.$store.getters["App/user"] || {};
      return !!user.billing_admin;
    },
  },
  methods: {
    openUpgrade() {
      track("ai_quota_hint_click", {
        where: this.where,
        remaining: this.remaining,
      });
      this.$eventbus.emit("Upgrade/open", { reason: "ai_limit" });
    },
  },
};
</script>

<style scoped>
.ai-quota-hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #7d8d92;
}
.ai-quota-hint.empty {
  color: #a1531a;
}
.ai-quota-hint button {
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: none;
  color: #127a8f;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  text-decoration: underline;
}
</style>
